/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Field Suggest Saga
 *
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.0.0
 */

import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import { API_HOSTNAME, FIELD_SUGGEST } from '../../../modules/app/Api';
import { requestSaga } from '../../../sagas/requestSaga';
import { sendFieldSuggestFailed, sendFieldSuggestSuccessful } from '../actions/tableActions';
import { makeSelectorTableCurrentName, makeSelectorTableFilterOptions } from '../selectors/tableSelectors';
import { MapTableNameToApiPath } from '../types/tableMapTypes';
import { ISendFieldSuggestPayload, TableNameType } from '../types/tableTypes';

export function* sendFieldSuggestSaga({ payload }: { payload: ISendFieldSuggestPayload; type: string }): SagaIterator {

    const tableName: TableNameType = yield select(makeSelectorTableCurrentName());
    const filterOptions = yield select(makeSelectorTableFilterOptions());
    // @ts-ignore
    const query = '/' + payload.field + '?term=' + encodeURIComponent(payload.value);
    const URL = API_HOSTNAME + MapTableNameToApiPath[tableName] + FIELD_SUGGEST + query;

    try {
        const suggest = yield call(requestSaga, URL, 'GET', null, {
            abortControllerId: MapTableNameToApiPath[tableName] + FIELD_SUGGEST,
        });
        const suggestList = get(suggest, 'suggestEntities', []);
        const newOptions = cloneDeep(filterOptions);
        newOptions[payload.field] = suggestList.map((item: { text: string }) => {
            return {
                label: item.text,
                value: item.text,
            }
        });
        yield put(sendFieldSuggestSuccessful(newOptions));
    } catch (error: any) {
        if (error.name !== 'AbortError') {
            yield put(sendFieldSuggestFailed(error));
        }
    }
}
